import { gql, useQuery } from "@apollo/client";
import { createContext, FC, useCallback, useContext, useReducer } from "react";
import { User } from "../api/schema";

export const users_query = gql`
  query Users {
    users {
      username
      displayname
      email
      id
      roles {
        id
        name
        permissions {
          id
          node
        }
      }
      permissions {
        id
        node
      }
    }
  }
`;

interface UsersQueryReponse {
  users: User[];
}

export const UserRepositoryContext = createContext<User[]>([]);

const RefetchRepositoryContext = createContext<() => void>(() => {});

export const UserRepositoryProvider: FC = ({ children }) => {
  const [state, dispatch] = useReducer(
    (__: User[], new_value: User[]) => new_value,
    []
  );

  const { refetch } = useQuery<UsersQueryReponse>(users_query, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      // console.log("got user list data", data);
      if (data.users) dispatch(data.users);
    },
    onError: (error) => {
      // console.log("got user list error", error);
    },
  });

  const fetch_new_data = useCallback(() => {
    // console.log("refetching...");
    refetch().then((v) => {
      if (v.error) {
        console.error(v.error);
      } else if (v.loading) {
        // console.log("loading...");
      } else if (v.data) {
        // console.log("setting new data");
        dispatch(v.data.users);
      }
    });
  }, [dispatch, refetch]);

  return (
    <UserRepositoryContext.Provider value={state}>
      <RefetchRepositoryContext.Provider value={fetch_new_data}>
        {children}
      </RefetchRepositoryContext.Provider>
    </UserRepositoryContext.Provider>
  );
};

export const useApiUsers = () => ({
  users: useContext(UserRepositoryContext),
  fetch_users: useContext(RefetchRepositoryContext),
});
